import React, {Component} from 'react'
import {MaterialReactTable} from 'material-react-table'
import { Container, Row, Col, Card, CardBody, Media, Button,
  Modal, ModalHeader, ModalBody, ModalFooter, TabPane,
} from 'reactstrap'
import { selectValues, getRegs, insert, update, insOrUp, getDocs } from '../../../utils/fc'



class DBTable extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: false,
      dataIsLoading: false,
      columns: [],
    }
  }

  componentDidMount() {
    this.preloading()
  }

  preloading = async () => {
    this.setState({dataIsLoading: true })
    const data = await getRegs(this.props.Table, this.props.Data, this.props.Fields)
    console.log("data do DBTable ", data)
    console.log("props do DBTable ", this.props.Columns)
    this.setState({ data, dataIsLoading: false, columns: this.props.Columns })
  }

   mapDBtoRMT = (columns) => {
    return columns.map(c => ({
      ...c,
      accessorFn: (row) => new Date(row.pf_dtNasc).toLocaleDateString('en-GB'),
      sortingFn: 'date',
//      Cell: ({ value }) => value, // Formata a data no formato desejado
    }))
  }

  render() {
    const { dataIsLoading, data, columns } = this.state

    if (dataIsLoading) {
      return (
        <Card>
          <CardBody>
            <span>Carregando...</span>
          </CardBody>
        </Card>
      )
    }

    if (data) {
      return (
        <MaterialReactTable
          columns={this.mapDBtoRMT(columns)}
          data={data}
        />
      )
    }

    return null
  }
}
export default DBTable
